export default __webpack_public_path__ + "static/media/camera-fov.37c13013.jpg";